import Model from './Model'

export default class MessageModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'messages'
  }
}
